export default __webpack_public_path__ + "static/media/project_funded_by.7ec3121a.jpg";